import { ValuableNode } from '../../models/ValuableNode'

export class SchemaBooleanNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Boolean': SchemaBooleanNode
  }
}
